import styles from "./LKebabDropdown.module.css";

export const LKebabDropdown = ({ elements }: LKebabDropdownProps): JSX.Element => {
    return (
        <div className={styles.dropdownContainer} tabIndex={1}>
            <div className={styles.threeDots}></div>
            <div className={styles.dropdown}>{elements}</div>
        </div>
    );
};

interface LKebabDropdownProps {
    elements: JSX.Element;
}
